var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardLinkSupportService(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0392 3.9704C30.4541 0.399148 25.2993 0 19 0C12.6927 0 7.53007 0.40375 3.9465 3.98465C0.363448 7.56406 0 12.7184 0 19.0184C0 25.3195 0.363448 30.4754 3.94798 34.0561C7.53133 37.6375 12.6934 38 19 38C25.3066 38 30.4678 37.6375 34.0511 34.0561C37.6354 30.4748 37.9999 25.3195 37.9999 19.0184C37.9999 12.7103 37.6315 7.55041 34.0392 3.9704Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9792 23.75C13.9792 24.6129 13.2492 25.3125 12.3488 25.3125C10.5478 25.3125 9.08789 23.9134 9.08789 22.1875V20.625C9.08789 18.8991 10.5478 17.5 12.3488 17.5C13.2492 17.5 13.9792 18.1996 13.9792 19.0625V23.75Z",
    stroke: "#00453C",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3496 17.5V14.6875C12.3496 12.0987 14.5395 10 17.2409 10H20.5018C23.2032 10 25.3931 12.0987 25.3931 14.6875M18.8713 28.4375H14.7953C13.4446 28.4375 12.3496 27.3882 12.3496 26.0938V25.3125",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3276 19.0625C28.3276 18.2031 27.5939 17.5 26.6972 17.5H20.5015C19.6048 17.5 18.8711 18.2031 18.8711 19.0625V25.3125C19.388 24.8171 20.0017 24.4242 20.6771 24.1561C21.3524 23.888 22.0763 23.75 22.8073 23.75H26.6972C27.5939 23.75 28.3276 23.0469 28.3276 22.1875V19.0625Z",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1309 20.625H25.0656",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLinkSupportService);
export default __webpack_public_path__ + "static/media/card_link_support_service.d62e415945a1142967dc70bfe0c4854b.svg";
export { ForwardRef as ReactComponent };